import ServiceSection from '../ServiceSection'
import './AboutSection.css'

export default function AboutSection() {
  return (
    <section className="section" aria-labelledby="services-title">
      <ServiceSection />
    </section>
  )
}
